module.exports = __webpack_public_path__ + "static/media/A-Gift-from-God-Death.5b71c990.jpg";